module.exports = __webpack_public_path__ + "img/media-11.7864c3b6.png";